import { render, staticRenderFns } from "./samecityList_new.vue?vue&type=template&id=6f032da3&scoped=true"
import script from "./samecityList_new.vue?vue&type=script&lang=js"
export * from "./samecityList_new.vue?vue&type=script&lang=js"
import style0 from "./samecityList_new.vue?vue&type=style&index=0&id=6f032da3&prod&lang=css"
import style1 from "./samecityList_new.vue?vue&type=style&index=1&id=6f032da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f032da3",
  null
  
)

export default component.exports